<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { censusnum } from "@/api/index";
export default {
  name: "App",
  destroyed() {
    window.removeEventListener("beforeunload", e =>
      this.beforeunloadHandler(e)
    );
    // alert("销毁页面");
  },
  mounted() {
    window.addEventListener("beforeunload", e => this.beforeunloadHandler(e));
    // 这里需要加访问量接口
    censusnum();
    // alert("重新加载页面");
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log(val, oldVal);
        // 这里需要加访问量接口
        censusnum();
        // alert("加载页面");
      }
    }
  },
  methods: {
    beforeunloadHandler(e) {
      // 这里需要加访问量接口
      censusnum();
      // console.log("关闭窗口之后");
    }
  }
};
</script>

<style>
/* 字体 */
@font-face {
  font-family: "SiYuanSongTi";
  /* src: url("../public/fonts/SourceHanSerifCN-Bold-2.otf"); */
}

/* iconfont */
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

/* 清除所有元素的内外边距和重置盒子模型 */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  min-width: 1200px;
}

/* 清除列表元素的列表符号 */
ul,
ol,
li {
  list-style: none;
}

/* 清除a链接下划线 */
a {
  text-decoration: none;
}

/* 数字字体 */
.number {
  font-family: "SiYuanSongTi";
}

/* 主题色 */
:root {
  --main-color: #b71112;
  --main-linear-gradient: linear-gradient(0deg, #aa233d 0%, #e53b45 100%);
  --main-yellow: #f7f499;
  --main-linear-gradient-yellow: linear-gradient(
    0deg,
    #ec9616 0%,
    #ffeeb4 100%
  );
  --main-linear-gradient-two: linear-gradient(0deg, #c00304 0%, #f26363 100%);
}

/* 主体内容宽度 */
.main-content {
  width: 1200px;
  margin: 0 auto;
}

/* 默认鼠标悬浮过渡效果 */
.def-hover-trs {
  transition: all 0.4s;
}
.def-hover-trs:hover {
  opacity: 0.8;
}

/* 重写ElementUI分页样式 */
.el-pagination {
  text-align: center;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  font-size: 16px;
  color: #666666;
  font-weight: normal;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--main-color) !important;
}
.el-pagination.is-background .btn-next:not(.disabled):hover,
.el-pagination.is-background .btn-prev:not(.disabled):hover,
.el-pagination.is-background .el-pager li:not(.active):not(.disabled):hover {
  color: var(--main-color) !important;
}
.el-pager li,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  height: 36px !important;
  line-height: 36px !important;
  padding: 0 14px !important;
  border-radius: 6px !important;
}
.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  font-size: 14px !important;
}

/* DateTime */
.el-time-panel__content::after,
.el-time-panel__content::before {
  margin-top: -7px !important;
}

/* 空状态的文字颜色 */
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 160px 20px;
}
.empty .el-empty__description {
  color: #999999;
  margin-top: 10px;
}

/* 内页通用样式 */
.common-inner-wrapper {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2px 2px 70px 2px;
}
/* 内页通用图片标题 */
.common-inner-wrapper .title-image {
  display: block;
  margin: 74px auto 54px;
}

.common-inner-header-wrapper .ornamental-image {
  position: absolute;
  z-index: 10;
  bottom: 2px;
  left: -10px;
}
.common-inner-header-wrapper .title-box {
  display: flex;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
}
.common-inner-header-wrapper .title-box .line {
  display: block;
  width: 2px;
  height: 32px;
  background-color: #ffedb2;
  margin: 0 20px;
  opacity: 0.6;
}
.common-inner-header-wrapper .title-box .subtitle {
  color: #ffedb2;
  font-size: 24px;
  font-weight: normal;
}
.common-inner-header-wrapper .search-box {
  display: flex;
  align-items: center;
  width: 280px;
  height: 48px;
  background-color: rgba(211, 41, 41, 0.7);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.common-inner-header-wrapper .search-input {
  background: none;
  border: none;
  outline: none;
  flex: 1;
  overflow: hidden;
  height: 100%;
  padding: 0 20px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
}
.common-inner-header-wrapper .search-input::placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.common-inner-header-wrapper .search-btn {
  width: 75px;
  height: 100%;
  display: flex;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  background: var(--main-linear-gradient-yellow);
  color: var(--main-color);
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
}
/* 内页通用筛选区域 */
.common-inner-screen-wrapper {
  padding: 50px 96px;
  background-color: #f1f2f2;
  line-height: 1;
}
.common-inner-screen-wrapper .screen-group {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.common-inner-screen-wrapper .screen-group-label {
  flex-shrink: 0;
  font-size: 18px;
  color: #000000;
  margin-right: 16px;
}
.common-inner-screen-wrapper .screen-group-value {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #878787;
  position: relative;
  padding-right: 60px;
}
.common-inner-screen-wrapper .more-box {
  position: absolute;
  right: 0;
  top: 17px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.4s;
}
.common-inner-screen-wrapper .more-box:hover {
  color: var(--main-color);
}
.common-inner-screen-wrapper .more-icon {
  transition: all 0.4s;
}
.common-inner-screen-wrapper .screen-group.open .more-icon {
  transform: rotate(180deg);
}
.common-inner-screen-wrapper .screen-group.border .screen-group-value {
  border-bottom: 1px dashed #cdcdcd;
  padding-bottom: 20px;
}
.common-inner-screen-wrapper .screen-group.label-top {
  align-items: flex-start;
}
.common-inner-screen-wrapper .screen-group.label-top .screen-group-label {
  transform: translateY(14px);
}
.common-inner-screen-wrapper .options-box {
  margin: 0 -10px;
  padding-left: 10px;
}
.common-inner-screen-wrapper .screen-group.open-close .options-box {
  height: 44px;
  overflow: hidden;
}
.common-inner-screen-wrapper .screen-group.open-close.open .options-box {
  height: auto;
}
.common-inner-screen-wrapper .option {
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.4s;
  border-radius: 6px;
  display: inline-block;
  margin: 6px;
}
.common-inner-screen-wrapper .option.active {
  background: var(--main-linear-gradient-two);
  color: #ffffff;
}
.common-inner-screen-wrapper .option:not(.active):hover {
  color: var(--main-color);
}
.common-inner-screen-wrapper .search-box {
  display: flex;
  align-items: center;
  width: 280px;
  height: 48px;
  background-color: #f9f9f9;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
}
.common-inner-screen-wrapper .search-input {
  background: none;
  border: none;
  outline: none;
  flex: 1;
  overflow: hidden;
  height: 100%;
  padding: 0 20px;
  font-size: 16px;
  color: #878787;
}
.common-inner-screen-wrapper .search-input::placeholder {
  color: #878787;
}
.common-inner-screen-wrapper .search-btn {
  width: 75px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--main-linear-gradient-two);
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
}
.common-inner-screen-wrapper .reset-btn {
  width: 75px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--main-linear-gradient-two);
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  border-radius: 6px;
  margin-left: 30px;
}
.common-inner-screen-wrapper .selectes-wrapper {
  display: flex;
  padding-top: 10px;
}
.common-inner-screen-wrapper .select-group {
  display: flex;
  align-items: center;
}
.common-inner-screen-wrapper .select-label {
  flex-shrink: 0;
  font-size: 18px;
  color: #000000;
  margin-right: 16px;
}
.common-inner-screen-wrapper .el-select .el-input__inner {
  height: 48px;
  font-size: 16px;
  color: #878787;
}

/* 通用标题 */
.common-module-title-wrapper {
  font-size: 24px;
  font-weight: bold;
  border-bottom: 1px solid rgba(205, 205, 205, 0.8);
  line-height: 1;
  color: var(--main-color);
}
.common-module-title-wrapper .title {
  position: relative;
  padding: 12px 0;
  display: inline-block;
}
.common-module-title-wrapper .title::after {
  content: "";
  width: 100%;
  height: 3px;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 10;
  background-color: var(--main-color);
}

/* 查看详情链接 */
.link-see-details {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: var(--main-color);
}
.link-see-details .arrow-details {
  margin-left: 2px;
  font-weight: bold;
}

/* 去这里链接 */
.link-go-this {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: var(--main-color);
}
.link-go-this .arrow-go {
  margin-left: 2px;
  transform: translateY(1px);
}

/* 更多链接 */
.link-more-info {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
}
.link-more-info .arrow-more {
  margin-left: 2px;
  transform: translateY(1px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue